export class CartClass {
    order_master:  OrderMaster;
    order_details: OrderDetail[];
    has_fundraiser: number;
}

export class OrderDetail {
    id:                number;
    item_id:           number;
    qty_ordered:       number;
    amount:            number;
    item_name:         string;
    short_description: string;
    lq_image:          string;
    item_category:     number;
    minimum_amount:    number;
    donation_amount: number;
}

export class OrderMaster {
    id:           number;
    total_amount: number;
    comment:string;
}
